module.exports = __webpack_public_path__ + "static/img/minicon4.09df45aa.png";